(function(){
function init(root){
  if(!root||root.dataset.hfrInit==='1')return; root.dataset.hfrInit='1';
  var list=root.querySelector('[data-list]'); if(!list)return;
  var items=[].slice.call(list.querySelectorAll('[data-item]'));
  var perPage=parseInt(root.dataset.perPage,10)||6;
  var moreWrap=root.querySelector('[data-more-wrap]');
  var moreBtn=root.querySelector('[data-more]');
  var sortSel=root.querySelector('[data-sort]');
  var rows=[].slice.call(root.querySelectorAll('[data-star]'));
  var clearBtn=root.querySelector('[data-clear]');
  var countEl=root.querySelector('[data-shown]');
  var emptyEl=root.querySelector('[data-empty]');
  var filter=0, shown=perPage;

  function matching(){ return items.filter(function(el){ return filter===0||parseInt(el.dataset.rating,10)===filter; }); }

  function render(){
    var vis=matching();
    items.forEach(function(el){ el.hidden=true; });
    vis.slice(0,shown).forEach(function(el){ el.hidden=false; });
    if(moreWrap) moreWrap.style.display = vis.length>shown ? '' : 'none';
    if(moreBtn) moreBtn.textContent=(moreBtn.dataset.label||'Show more').replace('[n]', vis.length-shown);
    if(emptyEl) emptyEl.hidden = vis.length!==0;
    if(clearBtn) clearBtn.hidden = filter===0;
    if(countEl) countEl.textContent=(countEl.dataset.label||'').replace('[shown]',Math.min(shown,vis.length)).replace('[total]',vis.length);
    rows.forEach(function(r){ r.setAttribute('aria-pressed', String(parseInt(r.dataset.star,10)===filter)); });
  }

  function sortBy(mode){
    var arr=items.slice();
    if(mode==='high') arr.sort(function(a,b){ return b.dataset.rating-a.dataset.rating || a.dataset.index-b.dataset.index; });
    else if(mode==='low') arr.sort(function(a,b){ return a.dataset.rating-b.dataset.rating || a.dataset.index-b.dataset.index; });
    else arr.sort(function(a,b){ return a.dataset.index-b.dataset.index; });
    arr.forEach(function(el){ list.appendChild(el); });
  }

  rows.forEach(function(r){ r.addEventListener('click',function(){
    var v=parseInt(r.dataset.star,10);
    filter = (filter===v) ? 0 : v; shown=perPage; render();
  }); });
  if(clearBtn) clearBtn.addEventListener('click',function(){ filter=0; shown=perPage; render(); });
  if(moreBtn) moreBtn.addEventListener('click',function(){ shown+=perPage; render(); });
  if(sortSel) sortSel.addEventListener('change',function(){ sortBy(sortSel.value); shown=perPage; render(); });

  var modal=root.querySelector('[data-modal]');
  if(modal){
    var openers=[].slice.call(root.querySelectorAll('[data-open]'));
    function open(){ modal.classList.add('open'); document.documentElement.style.overflow='hidden'; var f=modal.querySelector('input,textarea'); if(f) f.focus(); }
    function close(){ modal.classList.remove('open'); document.documentElement.style.overflow=''; }
    openers.forEach(function(b){ b.addEventListener('click',open); });
    modal.addEventListener('click',function(e){ if(e.target===modal||e.target.hasAttribute('data-close')) close(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&modal.classList.contains('open')) close(); });
    if(modal.dataset.autoOpen==='1') open();

    var radios=[].slice.call(modal.querySelectorAll('[data-rate] input'));
    function paint(){
      var sel=0;
      radios.forEach(function(r){ if(r.checked) sel=parseInt(r.value,10); });
      radios.forEach(function(r){
        var lab=modal.querySelector('label[for="'+r.id+'"]');
        if(lab) lab.classList.toggle('on', parseInt(r.value,10)<=sel);
      });
    }
    radios.forEach(function(r){ r.addEventListener('change',paint); });
    paint();
  }

  sortBy(sortSel?sortSel.value:'recent');
  render();
}

function boot(){ [].slice.call(document.querySelectorAll('[data-hfr2]')).forEach(init); }
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('[data-hfr2]'); if(r) init(r); });
})();
